<template>
    <div>
        <div class="elementor-element">
            <div class="elementor-widget-container">
                <h1 class="text-center my-4">Sign In</h1>
            </div>
        </div>
        <sign-in-register @success="signin" default-tab="signin"></sign-in-register>
    </div>
</template>
<script>
    import SignInRegister from '../components/signin/SignInRegister';

    export default {
        props: ['redirecturl'],
        components: {
            SignInRegister
        },
        data: function () {
            return {

            }
        },
        methods: {
            signin() {
                window.location.replace(this.redirecturl || '/');
            }
        }
    }
</script>